<template>
    <div class="bg-white text-center cursor-pointer hover:shadow p-4 h-full" @click="setElement">
        <img
            :src="item.bilde"
            class="inline"
        />
        <h3 class="mt-4 pt-2 border-t-2 border-gray-400 font-bold text-base">
            {{ item.navn }}
        </h3>
        <p>
            {{ item.antall }} tiltak
        </p>
    </div>
</template>

<script>
export default {
    props: ['item'],
    methods: {
        setElement() {
            const data = {
                type: 'counties',
                item: this.item
            };
            this.$emit('clicked', data);
        }
    }
};
</script>
